import { render } from "./GiftItemSendPopup.vue?vue&type=template&id=250961c6&scoped=true"
import script from "./GiftItemSendPopup.vue?vue&type=script&lang=js"
export * from "./GiftItemSendPopup.vue?vue&type=script&lang=js"

import "./GiftItemSendPopup.vue?vue&type=style&index=0&id=250961c6&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250961c6"]])

export default __exports__